export default __webpack_public_path__ + "static/media/ep22.e9a76643.jpeg";